import React, { useState, useEffect, useCallback } from 'react'
import Emitter from '@utils/eventEmitter'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@mui/material'

const Alert = () => {
  const [ show, setShow ] = useState(false)
  const [ text, setText ] = useState('')
  const [ buttonText, setButtonText ] = useState('확인')
  const [ cancelCb, setCancelCb ] = useState(null)

  const hideAlert = () => {
    setShow(false)
    setText('')
    setButtonText('확인')
    setCancelCb(null)
  }

  const showAlert = useCallback(({ show, text, buttonText, cancelCb }) => {
    setText(text || '')
    setButtonText(buttonText || '확인')
    setShow(true)
    setCancelCb(() => { return (cancelCb || hideAlert) })
  }, [])

  useEffect(() => {
    Emitter.on('SHOW_ALERT', showAlert)
    Emitter.on('HIDE_ALERT', hideAlert)
    return () => {
      Emitter.off('SHOW_ALERT')
      Emitter.off('HIDE_ALERT')
    }
  }, [ showAlert ])

  return (
    <>
      {
        show ?  <Dialog
          maxWidth={'xs'}
          open={show}
          fullWidth={true}
          onClose={hideAlert}
        >
          <DialogContent>
            <DialogContentText>{text}</DialogContentText>
          </DialogContent>
          <DialogActions style={{alignSelf: 'center'}}>
            <Button variant="contained" onClick={cancelCb} disableElevation>{buttonText}</Button>
          </DialogActions>
        </Dialog> : ''
      }
    </>
  )

}

export default Alert